import { render } from "./Farmers.vue?vue&type=template&id=37421b2f"
import script from "./Farmers.vue?vue&type=script&lang=js"
export * from "./Farmers.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/Partials/Farmers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37421b2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37421b2f', __exports__)) {
    console.log('reload')
    api.reload('37421b2f', __exports__)
  }
  
  module.hot.accept("./Farmers.vue?vue&type=template&id=37421b2f", () => {
    console.log('re-render')
    api.rerender('37421b2f', render)
  })

}


export default __exports__